/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    import ILocation = DealerwareWebServices.ILocation;

    export interface ILocationSummaryFormDirectiveControllerScope extends ng.IScope {
        locationSummaryForm: ng.IFormController;
    }

    export class LocationSummaryFormDirectiveController {

        public static $inject : string[] = [
            'DataUtils',
            '$scope',
            '$dealerwareLoading',
            '$dealerwareNotification'
        ];

        public location     : ILocation;
        private dataUtils   : any;

        constructor(public DataUtils: any,
                    public $scope: ILocationSummaryFormDirectiveControllerScope,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any) {
            this.dataUtils = DataUtils.getInstance();
            this.$scope = $scope;
        }

        public save() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            this.location.save().then((location: ILocation) => {
                _self.location = location;
                loader.close();
                _self.$dealerwareNotification.toast('Location saved');
            }).catch((response: any) => {
                _self.$dealerwareNotification.apiError(response);
            });
        }

        public isSaveDisabled () : boolean {
            if (this.$scope.locationSummaryForm && this.location) {
                return (this.$scope.locationSummaryForm.$invalid
                        || this.$scope.locationSummaryForm.$pristine
                        || this.location.isLocationExistingOrUnchanged());
            }

            return true;
        }

        public formatPhoneNumber (formatArgs : any) : any {
            return this.dataUtils.formatPhoneNumber(formatArgs);
        }
    }

    getDealerwareWebComponentsModule().controller('LocationSummaryFormDirectiveController', LocationSummaryFormDirectiveController);


    export class LocationSummaryFormDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'LocationSummaryFormDirectiveController';
        public controllerAs     : string    =   'locationSummaryController';
        public bindToController : boolean   =   true;
        public scope            : Object    =   { location: '=' };
        public templateUrl      : string    =   '/components/location/location-summary-form-directive.html';
    }

    getDealerwareWebComponentsModule().directive("dealerwareLocationSummaryForm",() => new LocationSummaryFormDirective());
}
